module.exports = __webpack_public_path__ + "static/media/youre-on-the-list-cover.e23df26a.png";